import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { QuestionSearchSortBy } from 'src/modules/exam-preparation/graphql/question/types';
import { getSafeData } from '../utils';
import { applySorting, isDuplicateQuestion } from './utils';
function getListForTopicQuery(topic, ancestorID) {
    return db.qnaNode
        .where('ancestors')
        .equals(ancestorID)
        .and(node => {
        const isQuestionType = [NodeType.WRITTEN_QUESTION, NodeType.ORALS_QUESTION].includes(node.type);
        const hasTopic = topic !== 'others'
            ? Boolean(node.data.topics?.includes(topic))
            : (node.data.topics?.length ?? 0) === 0;
        return isQuestionType && hasTopic && !node.deleted && !isDuplicateQuestion(node);
    });
}
export const getListForTopic = async (userID, topic, ancestorID, pagination = { offset: 0, limit: 20 }) => {
    const query = getListForTopicQuery(topic, ancestorID);
    // First, get all matching questions
    const questions = await query.toArray();
    const sortedQuestions = await applySorting(userID, questions, QuestionSearchSortBy.QP_DATE);
    const { offset = 0, limit = 20 } = pagination;
    const paginatedQuestions = sortedQuestions.slice(offset, offset + limit);
    return {
        list: paginatedQuestions.map(getSafeData),
        totalCount: questions.length,
    };
};
